import {createSlice} from '@reduxjs/toolkit';
import {isNewAPI} from '../../utils/utils';

const initialState = {
   scratchPadRecord: null,
   currentPageWithRespectiveModule: 0,
};

const ScratchPadRecordSlice = createSlice({
   name: 'scratchPadRecord',
   initialState,
   reducers: {
      setScratchPadRecord: (state, action) => {
         state.scratchPadRecord = action.payload.scratchPadRecord;
      },

      setCurrentPageWithRespectiveModule: (state, action) => {
         const temPayload = action.payload;
         const moduleId = temPayload.moduleID;
         const updatedPageNumber = temPayload.pageNumber;
         var temScratchPad = JSON.parse(state.scratchPadRecord);
         var mPadRecord = isNewAPI
            ? temScratchPad.ScratchPadRecordsList
            : temScratchPad.scratchPadRecord;
         const pageNumber = parseInt(
            isNewAPI
               ? mPadRecord[moduleId].ModulePageNumber
               : mPadRecord[moduleId].PageNumber,
         );
         const intUpdatedPageNumber = parseInt(updatedPageNumber);
         if (intUpdatedPageNumber > pageNumber) {
            if (isNewAPI) {
               mPadRecord[moduleId].ModulePageNumber = updatedPageNumber;
            } else {
               mPadRecord[moduleId].PageNumber = updatedPageNumber;
            }
            const updatedScratchPadRecord = isNewAPI
               ? {ScratchPadRecordsList: mPadRecord}
               : {scratchPadRecord: mPadRecord};
            state.scratchPadRecord = JSON.stringify(updatedScratchPadRecord);
         }
      },
   },
});

export const {setScratchPadRecord} = ScratchPadRecordSlice.actions;
export const {setCurrentPageWithRespectiveModule} =
   ScratchPadRecordSlice.actions;
export const selectedScratchPadRecord = state =>
   state.scratchPadRecord.scratchPadRecord;
export default ScratchPadRecordSlice.reducer;
